import { io, Socket } from 'socket.io-client';
import { type PublicShareRevisionEvent } from '@digital-twins/shared-types';

let publicSocket: Socket | null = null;
const desiredPublicShareSubscriptions = new Set<string>();

function publicSocketInstance(): Socket {
  if (!publicSocket) {
    const baseUrl =
      typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : '';
    publicSocket = io(`${baseUrl}/public`, {
      transports: ['websocket', 'polling'],
      path: '/api/socket.io/',
      autoConnect: true,
      withCredentials: true,
    });
    publicSocket.on('connect', () => {
      for (const shareToken of desiredPublicShareSubscriptions) {
        publicSocket?.emit('subscribe-public-share', { shareToken });
      }
    });
  }
  return publicSocket;
}

export function subscribeToPublicShare(shareToken: string): void {
  desiredPublicShareSubscriptions.add(shareToken);
  const ws = publicSocketInstance();
  ws.emit('subscribe-public-share', { shareToken });
}

export function unsubscribeFromPublicShare(shareToken: string): void {
  desiredPublicShareSubscriptions.delete(shareToken);
  const ws = publicSocketInstance();
  if (ws.connected) {
    ws.emit('unsubscribe-public-share', { shareToken });
  }
}

export function onPublicShareRevision(
  shareToken: string,
  callback: (payload: PublicShareRevisionEvent) => void,
): () => void {
  const ws = publicSocketInstance();
  const event = `public-share:${shareToken}:revision`;
  ws.on(event, callback);
  return () => ws.off(event, callback);
}

